import React, { Component } from 'react'

class PasswordResetSuccess extends Component {
  render() {

    return (
      <div className="container auth">
        <div className="dialog login" style={{textAlign: 'center'}}>
          <h3>Password Reset Success</h3>
          You have successfully reset your password.<br />To log in with your new password, click <a href="/login">here</a>
        </div>
      </div>
    )
  }
}

export default PasswordResetSuccess


// WEBPACK FOOTER //
// client/components/auth/PasswordResetSuccess.js